import styled from 'styled-components'

export const Preview = styled.div`
  position: relative;
  display: inline-block;
  cursor:pointer;
  width: 100%;
  i {
    color: #fff;
    opacity: 0;
    margin:0 auto;
    position : absolute;
    top: 50%;
    left: 50%;
    transition: .5s ease;
    transform: translate(-50%, -50%);
  }
  &:hover i {
    opacity: 1;
  }

  @media screen and (max-width: 767px) {
    margin: 0px;
  }
  
  /* Small devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991px) {
    margin: 16px;
  }
  
  /* tablets/desktops and up ———– */
  @media (min-width: 992px) and (max-width: 1199px) {
    margin-top: 48px;
    margin-left: 16px;
  }
  
  /* large desktops and up ———– */
  @media screen and (min-width: 1200px) {
    margin-top: 48px;
  }
  
  .bmpui-ui-watermark {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/styled/preview.js